import "./App.css";
import "./Styles/fontfamily.css";

import NavbarComp from "./Component/NavbarComp";
import { FooterComp } from "./Component/FooterComp";

import MainRoutes from "./Pages/MainRoutes";
import { BrowserRouter, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { HelmetProvider } from "react-helmet-async";

function App() {
  const helmetContext = {};

  const [showFooter, setShowFooter] = useState(false);
  const location = useLocation();
  const hideNavAndFooter = location.pathname === '/subscribe';
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowFooter(true);
    }, 2000); // 2 seconds
    return () => clearTimeout(timer); // cleanup on unmount
  }, []);

  return (
    <>
      {/* <BrowserRouter>
    
    <NavbarComp />
    <MainRoutes />
    <FooterComp />
    </BrowserRouter> */}

      <div>
        <HelmetProvider context={helmetContext}>
          {/* <Navbar /> */}
          {!hideNavAndFooter && <NavbarComp />}

          <MainRoutes />
          {/* {showFooter && <Footer />} */}
          {!hideNavAndFooter && showFooter && <FooterComp />}
        </HelmetProvider>
      </div>
    </>
  );
}

export default App;
